angular.module('bmsApp.settings').factory('CustomerReminderTemplateSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		read: function (licenceId) {
			return CRUDSvc.get('api/settings/reminder-templates/read/' + licenceId);
		},
		save: function (params) {
			return CRUDSvc.post('api/settings/reminder-templates/save', params);
		}
	}

});

